import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Callout } from '@blueprintjs/core';

export default class extends PureComponent {
  static propTypes = {
    describedError: PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.number,
      className: PropTypes.string,
      data: PropTypes.shape({
        type: PropTypes.string.isRequired,
        payload: PropTypes.object,
      }),
    }),
  };

  render() {
    const { describedError, ...restProps } = this.props;
    const {
      data: { payload },
    } = describedError;
    const { intent, title, description } = payload;

    return (
      <Callout intent={intent} title={title} {...restProps}>
        {description}
      </Callout>
    );
  }
}
